import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import FormGroup from '@mui/material/FormGroup';

const FilterCheckboxGroup = ({
  selectedValue = '',
  fieldIndex,
  sectionIndex,
  onChangeFilterValue,
  options,
  source,
}) => {
  let isTrueChecked, isFalseChecked;

  if (selectedValue === 'none') {
    isTrueChecked = false;
    isFalseChecked = false;
  } else if (selectedValue === '' || selectedValue === 'all') {
    isTrueChecked = true;
    isFalseChecked = true;
  } else {
    isTrueChecked = selectedValue === 'true';
    isFalseChecked = selectedValue === 'false';
  }

  const handleCheckboxChange = checkboxValue => {
    let newValue = '';

    if (checkboxValue === 'true') {
      if (selectedValue === '' || selectedValue === 'all') {
        newValue = 'false';
      } else if (selectedValue === 'true') {
        newValue = 'none';
      } else if (selectedValue === 'false') {
        newValue = 'all';
      } else if (selectedValue === 'none') {
        newValue = 'true';
      }
    } else {
      if (selectedValue === '' || selectedValue === 'all') {
        newValue = 'true';
      } else if (selectedValue === 'false') {
        newValue = 'none';
      } else if (selectedValue === 'true') {
        newValue = 'all';
      } else if (selectedValue === 'none') {
        newValue = 'false';
      }
    }

    onChangeFilterValue({
      source,
      fieldIndex,
      sectionIndex,
      fieldValue: newValue,
    });
  };

  return (
    <Box display="flex" ml={2}>
      <FormGroup>
        {options?.map(opt => (
          <FormControlLabel
            key={opt.value.toString()}
            control={
              <Checkbox
                size="small"
                checked={opt.value ? isTrueChecked : isFalseChecked}
                onChange={() => handleCheckboxChange(String(opt.value))}
              />
            }
            label={opt.label}
          />
        ))}
      </FormGroup>
    </Box>
  );
};

export default FilterCheckboxGroup;
